"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanContactGroups = void 0;
exports.default = reducer;
exports.saveContactForm = exports.loadContactGroups = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _contactLoggedInApi = require("../api/contactLoggedInApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INIT_STATE = {
  response: {},
  groups: {},
  subjects: [],
  isRequestPending: false
};

// Actions
var GET_CONTACT_GROUPS = 'api/reducer/GET_CONTACT_GROUPS';
var SAVE_CONTACT_DETAILS = 'api/reducer/SAVE_CONTACT_DETAILS';
var RESET_CONTACT_STATE = 'api/reducer/DELETE_CONTACT_GROUPS';
var createSubjectsFromContactGroups = function createSubjectsFromContactGroups(data, reasonData) {
  var reasonDetails = [];
  Object.entries(data).filter(function (group, index) {
    return group[index] === 'groups';
  }).map(function (groupItem) {
    Object.keys(groupItem[1]).map(function (subjectItem) {
      var subjectData = reasonData[subjectItem];
      reasonDetails.push({
        content: subjectData,
        value: subjectItem
      });
      return reasonDetails;
    });
    return reasonDetails;
  });
  var sortedData = reasonDetails.sort(function (a, b) {
    return a.value - b.value;
  });
  return sortedData;
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_CONTACT_GROUPS:
      return _objectSpread(_objectSpread({}, state), {}, {
        response: action.data,
        groups: action.data.groups,
        subjects: createSubjectsFromContactGroups(action.data, action.payload)
      });
    case SAVE_CONTACT_DETAILS:
      return state;
    case RESET_CONTACT_STATE:
      return INIT_STATE;
    default:
      return state;
  }
}

// Action Creators
var loadContactGroups = exports.loadContactGroups = function loadContactGroups(dispatch, contractId, reasonData) {
  var resp = (0, _contactLoggedInApi.getContactGroups)(contractId);
  return resp.then(function (response) {
    dispatch({
      type: GET_CONTACT_GROUPS,
      data: response.data,
      payload: reasonData
    });
  });
};
var saveContactForm = exports.saveContactForm = function saveContactForm(dispatch, contractId, payload) {
  var resp = (0, _contactLoggedInApi.saveContactDetails)(contractId, payload);
  return resp.then(function (response) {
    dispatch({
      type: SAVE_CONTACT_DETAILS,
      data: response
    });
  });
};
var cleanContactGroups = exports.cleanContactGroups = function cleanContactGroups(dispatch) {
  dispatch({
    type: RESET_CONTACT_STATE
  });
};